import { withState } from 'recompose';

export default withState('phone', 'updatePhone', '');
